var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',{attrs:{"value":_vm.currentValue,"config":_vm.flatpickrConfig},on:{"on-change":_vm.handleChange,"on-close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }